import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Content from './Content';

const useStyles = makeStyles((theme) => ({
  
}));

function SpellingDictionary(props) {
  const classes = useStyles();
  
  return (
    <Content>
      <h1>SpellingDictionary</h1>
    </Content>
  );
}

export default SpellingDictionary;
